import { Component, computed, inject, signal } from '@angular/core';
import { BrandingService } from '../../branding/branding.service';

/**
 * The replica's logo from `GET /v1/branding` (`logo_url`). With none
 * configured it's the default brand's logo (`DEFAULT_BRANDING.logoUrl`). If the
 * image fails to load it falls back to the brand name as a text wordmark.
 */
@Component({
  selector: 'mars-logo',
  standalone: true,
  template: `
    @if (logoUrl(); as src) {
      <img
        class="block h-[41px] w-auto max-w-[180px] object-contain"
        [src]="src"
        [alt]="name()"
        (error)="failedSrc.set(src)" />
    } @else if (name()) {
      <span
        class="block font-bold leading-[41px] text-heading-6 text-supplier-500 whitespace-nowrap">
        {{ name() }}
      </span>
    }
  `,
})
export class LogoComponent {
  private readonly branding = inject(BrandingService);

  protected readonly name = this.branding.name;
  // Only the URL that failed is suppressed — a different one from the
  // background branding refresh is tried again.
  protected readonly failedSrc = signal<string | null>(null);
  protected readonly logoUrl = computed(() => {
    const src = this.branding.logoUrl();
    return src && src !== this.failedSrc() ? src : null;
  });
}
